<template>
  <main>
    <Hero :program="program" />
    <Trail />
  </main>
</template>

<script>
import programs from "@/data.js";
import Hero from "@/components/home/Hero";
import Trail from "@/components/common/Trail";

export default {
  components: {
    Hero,
    Trail
  },
  setup() {
    const program = programs[process.env.VUE_APP_PREFIX];
    return {
      program
    };
  }
};
</script>
<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
.trail {
  border-top: 1px solid variables.$border-header-color;
  margin-bottom: 0;
}
</style>
